<template>
    <el-select v-model='info'
     	placeholder="请输入内容" filterable remote
     	default-first-option clearable
      	:remote-method="search" :loading="loading"
        value-key="id" :size="size">
        <el-option v-for="item in list" :key="item.id"
         :label="item.name" :value="item">
        </el-option>
    </el-select>
</template>
<script scoped>
    import requestApi from '@/api/operateManage/guidemanage'
	export default {
		name: 'searchguideframerAuto',
		data() {
            return {
                list: [], //列表
                info: {},
                loading: false
            }
		},
		props: {
			/*
			    类别,可用值:CONSENSUS,GUIDE
			 */
		    searchKey: String,
			framerId: {
				type: String,
				default: () => ''
			},
			size: {
				type: String,
				default: () => 'medium'
			}
		},
		watch: {
			framerId: function(val) {
				this.select(val)
			}
		},
		mounted() {
			this.select(this.framerId)
		},
		methods: {
    		// 远程搜索医生
			search(e) {
				if(e === ''){ return }
				let params = {
					category: this.searchKey,
					framerName: e
				}
				this.loading = true
		      	requestApi.search_framer(params).then(res => {
			        if (res.Success) {
			          this.list = res.Data;
			        } else {
			          this.$message.error(res.Msg);
			        }
					this.loading = false
		      	}).catch(res => {
					this.loading = false
		      		this.$message.error('获取列表出错！')
		      	})
		    },
			select(id) {
				if(id === ''){ return }
				let params = {
					category: this.searchKey,
					framerId: id
				}
				this.loading = true
		      	requestApi.search_framer(params).then(res => {
			        if (res.Success) {
			          this.list = res.Data;
					  this.info = res.Data[0]
			        } else {
			          this.$message.error(res.Msg);
			        }
					this.loading = false
		      	}).catch(res => {
					this.loading = false
		      		this.$message.error('获取列表出错！')
		      	})
		    },
	        getInfo() {
	        	let data = this.info || {}
	        	return data
	        },
	        init() {
	        	this.info = {}
	        }
		}
	};
</script>

<style type="text/less" lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/components/searchguideframerAuto.vue